// ==================================
// Componente de Ruta Protegida
// ==================================

import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/estado/authStore';

export function PrivateRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default PrivateRoute;
